<template>
  <div class="third-part-login">
    <p id="sign-in-with">
      <span></span>
      <span>{{ $t('signInWith') }}</span>
      <span></span>
    </p>
    <template v-show="!isLoading">
      <!-- <a href="javascript:void(0)" @click="login('facebook')" v-if="showThirdPartLogin">
        <img src="/static/img/oAuthLogin/facebook.png" alt="facebook ">
      </a>-->
      <a :href="twitterLoginURL" @click="setRedirectUrlCookie">
        <img src="/static/img/oAuthLogin/twitter.png" alt="twitter" />
      </a>
      <wechat-login v-if="currentLang === 'zh' && mediaType === 'pc'"></wechat-login>
      <!-- <a href="javascript:void(0)" @click="login('vk')" class="vk" v-if="showThirdPartLogin">
        <img src="/static/img/oAuthLogin/vk.png" alt="vk">
      </a>-->
    </template>
    <spinner :show="isLoading" class="loading"></spinner>
  </div>
</template>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '../../../assets/scss/variables';
* {
  padding: 0;
  margin: 0;
  border: 0;
}

.third-part-login {
  width: 100%;
  margin: 40px auto 0;
  padding-bottom: 40px;
  text-align: center;
}

#sign-in-with {
  position: relative;
  min-width: 100px;
  text-align: center;
  color: #999;
  font-size: 0.16rem;
  line-height: 0.16rem;
  height: 0.14rem;
  letter-spacing: 0.7px;
  margin-bottom: 0.16rem;
  span:first-child,
  span:last-child {
    position: absolute;
    top: 0.07rem;
    border-bottom: 1px solid #efefef;
    width: calc((100% - 155px) / 2);
  }
  span:first-child {
    left: 0;
  }
  span:last-child {
    right: 0;
  }
}

a {
  display: inline;
  text-align: center;
  &:not(:last-child) {
    margin-right: 0.3rem;
  }
  img {
    max-width: 0.4rem;
  }
}

.vk {
  .icon {
    font-size: 0.3rem;
    margin-bottom: 0.03rem;
  }
}

@media (max-width: 767px) {
  #sign-in-with {
    font-size: 14px;
    line-height: 14px;
    span:first-child,
    span:last-child {
      width: calc((100% - 110px) / 2);
    }
  }
}
</style>

<script>
import hello from 'hellojs/dist/hello.all';
import Spinner from '../../Spinner.vue';
import WechatLogin from '../wechatLogin/WechatLogin.vue';
import locales from './lang';
import cookie from '../../../lib/cookie';
import { mapState } from 'vuex';
import { SET_USER_INFO } from '../../../store/mutation-types';

export default {
  name: 'other-login-view',
  components: {
    Spinner,
    WechatLogin
  },
  data: function () {
    return {
      isLoading: false
    };
  },
  locales,
  computed: {
    twitterLoginURL() {
      const inviteHost = window.location.href.match(/(\S*)\//)[1];
      const qrToken = window.sessionStorage.getItem('qr_token') || '';
      return `${inviteHost}/api/auth/twitter/redirect?web=1&lang=${this.currentLang}&qr_token=${encodeURIComponent(qrToken)}`;
    },
    ...mapState({
      currentLang: state => state.currentLang,
      mediaType: state => state.mediaType,
      redirectUrl: state => state.redirectUrl,
      clickIndexPagePackageData: state => state.clickIndexPagePackageData
    }),
    showThirdPartLogin() {
      if (process.env.NODE_ENV === 'production') {
        return false;
      } else return true;
    }
  },
  mounted: function () {
    hello.init(
      {
        facebook: process.env.FACEBOOK_ID,
        vk: process.env.VK_ID
      },
      {
        redirect_uri: '/redirect'
      }
    );
  },
  methods: {
    login: function (network) {
      let provider = hello(network);
      provider.login().then(response => {
        if (network === 'vk') {
          this.oauthLogin({
            provider: 'vkontakte',
            code: response.authResponse.access_token,
            vk_user_id: response.authResponse.user_id,
            qr_token: window.sessionStorage.getItem('qr_token') || ''
          });
        } else if (network === 'facebook') {
          this.oauthLogin({
            provider: network,
            code: response.authResponse.access_token,
            qr_token: window.sessionStorage.getItem('qr_token') || ''
          });
        }
      });
    },
    oauthLogin: function (data) {
      this.isLoading = true;
      this.$http.post('api/oauth-login', data).then(
        response => {
          if (response.data.code === 0) {
            if (response.data.meta) {
              this.$toast(response.data.meta.qr_message);
            } else {
              window.localStorage.setItem('token', response.data.data.access_token);
              window.sessionStorage.setItem('needUseNoCache', true);
              this.$store.commit(SET_USER_INFO, response.data.data);
              this.$router.push(this.redirectUrl);
            }
            this.isLoading = false;
          }
        },
        () => {
          this.isLoading = false;
        }
      );
    },
    setRedirectUrlCookie() {
      if (this.clickIndexPagePackageData) {
        localStorage.clickIndexPagePackageData = JSON.stringify(this.clickIndexPagePackageData);
      }
      if (this.redirectUrl !== '/dashboard') {
        cookie.setCookie('redirect_url', this.redirectUrl);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// ThirdPartLogin.vue?3ac420af